module.exports = __webpack_public_path__ + "image/quote-pic1.png";